<template>
<div class="the-login-form">
  <h3>Vstup do zákaznické samoobsluhy</h3>
  <form @submit.prevent="validateBeforeSubmit" class="form-horizontal" autocomplete="on">
    <div class="form-group">
      <label for="inputUsername" class="control-label">Klientské číslo</label>
      <div class="row">
        <div class="col-lg-4">
          <input type="text" ref="username" name="username" class="form-control" v-model="inputUsername"
          :disabled="submitPending" autofocus>
        </div>
        <div class="col-lg-8">
          <small>Klientské číslo je sedmimístné, např. 1012233. Odpovídá variabilnímu symbolu, který používáte pro platby trvalým příkazem za služby společnosti Rychlý drát, s.r.o. Na výpisu z Vaší banky jej najdete u odchozích plateb ve prospěch účtu 344355366/2010.</small>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="inputPassword" class="control-label">Heslo</label>
      <div class="row">
        <div class="col-lg-4">
          <input type="password" ref="password" name="password" class="form-control" v-model="inputPassword" :disabled="submitPending">
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="control-label" />
      <div class="col-lg-4">
        <div class="row">
          <button v-on:click="submitForm" class="btn btn-primary" :disabled="incompleteForm || submitPending">
            <span v-if="!submitPending">Přihlásit</span>
            <i v-if="submitPending" class="fa fa-spin fa-spinner" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="form-group">
        <a v-on:click="goToResetPassword" href="#">
          Vytvořit nový přístup - obnova zapomenutého hesla
        </a>
    </div>
    <div class="form-group" v-if="displayError">
      <div class="col-lg-12 error-box">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        {{ displayError }}
      </div>
    </div>
  </form>
</div>
</template>

<script>
import SessionResource from '../backend-resources/session-resource'

export default {
  name: 'login-component',
  data () {
    return {
      displayError: '',
      submitPending: false,
      inputUsername: '',
      inputPassword: '',
      success: null,
      customerInfo: null
    }
  },
  methods: {
    submitForm () {
      this.submitPending = true
      this.customerInfo = null
      let sr = new SessionResource()
      sr.createByPassword(this.inputUsername, this.inputPassword).then((response) => {
        this.submitPending = false
        this.success = true
        this.customerInfo = response.data
        this.$store.commit('loginSuccess', this.customerInfo)
        this.$emit('after-login')
      })
      .catch((error) => {
        this.submitPending = false
        this.success = false
        if (error.response && error.response.status === 401) {
          this.displayError = 'Neplatné klientské číslo a/nebo heslo.'
        } else if (error.response && error.response.status === 402) {
          this.displayError = 'Přístup zablokován pro dlouhodobé neplacení za služby.'
        } else if (error.response && error.response.status === 410) {
          this.displayError = 'Přístup ukončen. Žádné aktivní služby.'
        } else if (error.response && error.response.status) {
          this.displayError = error.response.status + ' ' + error.response.statusText
        } else {
          this.displayError = error.toString()
        }
        this.customerInfo = null
        this.$store.commit('loginFailure')
      })
    },
    goToResetPassword () {
      this.$router.push('/reset-password')
    },
    validateBeforeSubmit () {
      return true
    }
  },
  created: function () {
    if (this.$route.params.usernamedigits) {
      this.inputUsername = this.$route.params.usernamedigits
      setTimeout(() => { this.$refs.password.focus() }, 500)
    } else {
      setTimeout(() => { this.$refs.username.focus() }, 500)
    }
  },
  computed: {
    incompleteForm () {
      return this.inputUsername === '' || this.inputPassword === ''
    }
  }
}
</script>

<style scoped>
h3 {
  color: #0c71b7;
}
.the-login-form {
  max-width: 1000px;
  padding: 3rem 1rem;
  border-color: #e5e5e5 #eee #eee;
  border-style: solid;
  border-width: 1px;
  border-radius: 6px;
  -webkit-box-shadow: inset 0 3px 6px rgba(0,0,0,0.1);
          box-shadow: inset 0 3px 6px rgba(0,0,0,0.1);
}
button {
  width: 100%;
}
a {
  cursor: pointer;
}
small {
  color: gray;
}
</style>



// WEBPACK FOOTER //
// Login.vue?d2cfa876